import { Controller, SubmitHandler, useFormContext } from 'react-hook-form';
import {
  PrimaryButton, PrimaryTextField, ErrorMessage, SecondaryLink,
} from 'components';
import { IForgotPasswordForm } from 'base/auth/interface';

interface Props {
  onSubmit: SubmitHandler<any>;
}

const ForgotPasswordFormView = (props: Props) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useFormContext<IForgotPasswordForm>();
  const { onSubmit } = props;
  return (
    <form data-testid="forgot-password-form-video" onSubmit={handleSubmit(onSubmit)} style={{ textAlign: 'left' }}>
      <div className="form-item">
        <Controller
          control={control}
          name="name"
          render={({ field }) => <PrimaryTextField {...field} label="Email address" />}
        />
        <ErrorMessage>{errors?.name?.message}</ErrorMessage>
      </div>
      <div className="form-item text-center">
        <SecondaryLink to="/login">Back to signin in</SecondaryLink>
      </div>
      <div className="form-item">
        <PrimaryButton size="large" fullWidth type="submit">
          Get a code
        </PrimaryButton>
      </div>
    </form>
  );
};

export default ForgotPasswordFormView;
